import { gql } from "@apollo/client";
import {
  EventPolicyCompliance,
  eventPolicyComplianceFragment,
} from "common/graphql/fragments/eventPolicyComplianceFragment";

export const parkFragment = gql`
  fragment parkFragment on parks {
    startTime: start_time
    endTime: end_time
    startTimeLocal: start_time_local
    endTimeLocal: end_time_local
    policyRateDetails: event_policy_compliance_records {
      ...eventPolicyComplianceFragment
    }
  }
  ${eventPolicyComplianceFragment}
`;

export interface Park {
  startTime: string;
  // NULL while the park is live — a session that hasn't ended yet has no end
  // time. Typed non-nullable until AUT-5502, which hid the open-session case
  // from every consumer.
  endTime: string | null;
  startTimeLocal: string;
  endTimeLocal: string | null;
  policyRateDetails: EventPolicyCompliance[];
}
